import { amtStr } from 'helpers/numFormatter';
import React, { useContext, useEffect, useState } from 'react';
import './retail.scss';
import { Autocomplete } from '@material-ui/lab';
import {
	Button,
	Grid,
	MenuItem,
	TextField,
	useMediaQuery,
} from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import AppContext from 'containers/App/Store/AppContext';
import theme from '@ifca-root/react-component/src/assets/theme';

interface RetailPOSAmountFooterProps {
	currencyCode?: string;
	subtotal?: string;
	discount?: string;
	serviceTax?: string;
	total?: string;
	rounding?: string;
	page?: string;
	getFilteredDiscount?: any;
	outletID?: string;
	getOrder?: any;
	register?: any;
	control?: any;
	handleSubmit?: any;
	onSubmitOD?: any;
	voidRegister?: any;
	voidControl?: any;
	voidErrors?: any;
	voidWatch?: any;
	voidHandleSubmit?: any;
	getReason?: any;
	onSubmitVoid?: any;
	dispatch?: any;
}

export const RetailPOSAmountFooter: React.FC<RetailPOSAmountFooterProps> = ({
	currencyCode = '',
	subtotal = '0',
	discount = '0',
	serviceTax = '0',
	total = '0',
	rounding = '0',
	page = 'payment',
	getFilteredDiscount,
	outletID,
	getOrder,
	register,
	control,
	handleSubmit,
	onSubmitOD,
	voidRegister,
	voidControl,
	voidErrors,
	voidWatch,
	voidHandleSubmit,
	getReason,
	onSubmitVoid,
	dispatch,
}) => {
	const divChild = (info1: string, info2: string) => {
		return (
			<div className="retail-pos-amount-footer-child">
				<span>{info1}</span>
				<span className="retail-pos-amount-footer-right">{info2}</span>
			</div>
		);
	};

	const [selectedOption, setSelectedOption] = useState(null);
	const [isTouch, setIsTouch] = useState(false);
	const [display, setDisplay] = useState(null);

	const { globalState }: any = useContext(AppContext as any);

	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	useEffect(() => {
		const discountID = getOrder?.[0]?.orderDiscount?.[0]?.discountID;

		if (!discountID || !Array.isArray(getFilteredDiscount)) {
			setDisplay(null);
			return;
		}

		const matchedDiscount = getFilteredDiscount.find(x => x?.ID === discountID);

		setDisplay(matchedDiscount ?? null);
	}, [getFilteredDiscount, getOrder]);

	useEffect(() => {
		if (!control?.setValue) return;

		if (display) {
			control.setValue('discountCode', display);
		} else {
			control.setValue('discountCode', null);
		}
	}, [display, control]);

	console?.log(display, 'peak');

	return (
		<div
			className="retail-pos-amount-footer"
			// style={{
			// 	width:
			// 		isDesktop && globalState.drawerOpen
			// 			? 'calc((100% - 288px) * 5 / 12)'
			// 			: 'calc((100% - 48px) * 5 / 12)',
			// }}
		>
			<div className="retail-pos-amount-footer-title">Ordering Summary:</div>
			<div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
				<Controller
					name="discountCode"
					control={control}
					defaultValue={null}
					render={props => (
						<Autocomplete
							options={getFilteredDiscount}
							getOptionLabel={option => option?.code || ''}
							value={props.value}
							disabled={!!display}
							onChange={(_, value) => {
								props.onChange(value);
								setIsTouch(true);
								setSelectedOption(value);
							}}
							style={{ width: '65%' }}
							size="small"
							renderInput={params => (
								<TextField
									{...params}
									label="Discount Code"
									variant="outlined"
									size="small"
									InputProps={{
										...params.InputProps,
										style: {
											backgroundColor: '#fff',
											borderRadius: '8px',
											borderColor: 'orange',
											height: '36px',
										},
									}}
									InputLabelProps={{
										style: { color: 'orange', fontSize: '0.85rem' },
									}}
								/>
							)}
						/>
					)}
				/>

				<Button
					type="button"
					variant="outlined"
					style={{
						backgroundColor: '#fff',
						borderColor: display ? 'red' : 'orange',
						color: display ? 'red' : 'orange',
						padding: '5px 12px',
						borderRadius: '8px',
					}}
					onClick={() => {
						if (display) {
							// 🔴 VOID MODE
							dispatch({ type: 'voidDialog', payload: true });
						} else {
							// 🟢 APPLY MODE
							handleSubmit(onSubmitOD)();
						}
					}}
				>
					{display ? 'Cancel Discount' : 'Apply Discount'}
				</Button>
			</div>

			{/* <div style={{ paddingBottom: '10px' }} /> */}
			{divChild(
				'Total',
				`${currencyCode}${Number(subtotal || 0).toLocaleString('en-MY', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				})}`,
			)}
			{divChild('Discount', `(${currencyCode}${amtStr(discount)})`)}
			{page === 'payment' &&
				divChild(
					'Rounding',
					parseFloat(rounding) < 0
						? `(${currencyCode}${amtStr(rounding)})`
						: `${currencyCode}${amtStr(rounding)}`,
				)}
			<hr className="retail-pos-amount-line" />
			{/* <div style={{ paddingBottom: '10px' }} /> */}
			<div className="retail-pos-amount-footer-total">
				<span>Total Payable</span>
				<span className="retail-pos-amount-footer-right">
					{currencyCode +
						Number(total || 0).toLocaleString('en-MY', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})}
				</span>
			</div>
			{divChild(
				'Service Tax',
				`${currencyCode}${Number(serviceTax || 0).toLocaleString('en-MY', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				})}`,
			)}
		</div>
	);
};

export default RetailPOSAmountFooter;

export const VoidRetailODDialog = (props: any) => {
	const {
		state,
		dispatch,
		control,
		register,
		errors,
		watch,
		handleSubmit,
		getReason,
		onSubmitVoid,
		deleteOrderDiscountLoading,
	} = props;

	return (
		<>
			<CommonDialog
				fullWidth={true}
				open={state?.voidDialog}
				onClose={() => {
					dispatch({ type: 'isButtonClicked', payload: false });
					dispatch({ type: 'voidDialog', payload: false });
				}}
				sections={{
					header: {
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="title">{`Void ${
											state?.selectedOrderItem?.ID
												? 'Item Discount'
												: 'Discount'
										}`}</div>
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<>
							<div className="mdDesc">
								<Grid container className="mdDesc">
									<Grid item xs={12} style={{ marginBlockStart: '10px' }}>
										<Controller
											as={
												<TextField select size="small" label="Reason">
													{getReason?.map((x, index) => (
														<MenuItem key={index} value={x?.name}>
															{x?.name}
														</MenuItem>
													))}
												</TextField>
											}
											name="reasonCode"
											autoComplete="off"
											control={control}
											ref={register}
											multiline
											fullWidth
											required
											margin="normal"
											helperText={errors?.reasonCode?.message}
											error={errors?.reasonCode ? true : false}
										></Controller>
									</Grid>
									<Grid item xs={12}>
										<Controller
											as={<TextField />}
											name="remark"
											label="Remark"
											autoComplete="off"
											control={control}
											ref={register}
											multiline
											required
											fullWidth
											margin="normal"
											helperText={errors?.remark?.message}
											error={errors?.remark ? true : false}
										></Controller>
									</Grid>
								</Grid>
							</div>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => {
										dispatch({ type: 'isButtonClicked', payload: false });
										dispatch({ type: 'voidDialog', payload: false });
									},
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Confirm',
								props: {
									onClick: () => {
										// Disable the button immediately
										dispatch({ type: 'isButtonClicked', payload: true });
										handleSubmit(onSubmitVoid)();
									},
									variant: 'contained',
									type: 'submit',
									color:
										watch('reasonCode') === undefined ||
										watch('reasonCode') === null ||
										watch('remark') === undefined ||
										watch('remark') === null ||
										watch('remark') === '' ||
										deleteOrderDiscountLoading ||
										state?.isButtonClicked
											? 'inherit'
											: 'primary',
									disabled:
										watch('reasonCode') === undefined ||
										watch('reasonCode') === null ||
										watch('remark') === undefined ||
										watch('remark') === null ||
										watch('remark') === '' ||
										deleteOrderDiscountLoading ||
										state?.isButtonClicked,
								},
							},
						],
					},
				}}
			/>
		</>
	);
};
